import "./ZeroRequests.css";

const ZeroRequests = () => {
  return (
    <div className="ZeroRequests">
      <img
        src="https://static.thenounproject.com/png/4147383-200.png"
        alt="pending-icon"
      />
      <div className="ZeroRequests_content_header">No Results</div>
    </div>
  );
};

export default ZeroRequests;
